import {
  setOrgUnifiedProductPagesCustomisation,
  setUnifiedProductPagesLoad,
} from "@redux/slices/appStateSlice";
import { ThemeTokenTypes } from "@scenes/splash-screen/types";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { setUnifiedProductPages } from "@redux/slices/unifiedProductPages";

export const useUnifiedProductPagesData = (
  url: string,
  enabled?: boolean,
  type?: string
) => {
  const dispatch = useDispatch();
  const timestamp = Date.now();

  return useQuery({
    queryKey: ["GET_UNIFIED_PRODUCT_PAGES_DATA"],
    enabled: enabled,
    queryFn: () =>
      axios.get(url + "?timestamp=" + timestamp).then((data) => {
        if (type === ThemeTokenTypes.ORG) {
          dispatch(setOrgUnifiedProductPagesCustomisation(data.data));
        }
        if (type === ThemeTokenTypes.COMPANY) {
          dispatch(setUnifiedProductPagesLoad(true));
        }
        dispatch(setUnifiedProductPages(data.data));
        return data;
      }),
    onError: (err) => {
      console.log("err", err);
    },
  });
};
